'use strict';
import * as $j_java$002elang$002e$002dEnum from "./java.lang.-Enum.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ljava_math_RoundingMode(name, ordinal) {
  this.q = null;
  this.M = 0;
  $j_java$002elang$002e$002dEnum.$ct_jl_Enum__T__I__(this, name, ordinal);
}
export { $c_Ljava_math_RoundingMode as $c_Ljava_math_RoundingMode };
$p = $c_Ljava_math_RoundingMode.prototype = new $j_java$002elang$002e$002dEnum.$h_jl_Enum();
$p.constructor = $c_Ljava_math_RoundingMode;
/** @constructor */
function $h_Ljava_math_RoundingMode() {
}
export { $h_Ljava_math_RoundingMode as $h_Ljava_math_RoundingMode };
$h_Ljava_math_RoundingMode.prototype = $p;
var $d_Ljava_math_RoundingMode = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_RoundingMode, "java.math.RoundingMode", ({
  kF: 1,
  n: 1,
  j: 1,
  a: 1
}));
export { $d_Ljava_math_RoundingMode as $d_Ljava_math_RoundingMode };
